import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import { Link } from '@Components/Link'
import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './CheckoutFlowLogo.module.scss'

export const CheckoutFlowLogo: FC = () => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { storeURL } = useContext(MetadataContext)
  return (
    <Link className={clsx(styles.checkoutFlowLogo, cofDesignV1 && styles.cofDesignV1)} href={storeURL('/')}>
      <img
        alt="Trendhim"
        src="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt59296545a01439bf/trendhim-logo-with-text-v2.svg"
      />
    </Link>
  )
}
